// @flow

import React from 'react';

import {makeStyles, Typography} from '@material-ui/core';

import {colors} from '../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';

import type {Theme} from '@material-ui/core';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 360,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#313135',
  },
  text: {
    color: colors.grey800,
    fontSize: 16,
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  highlight: {
    color: colors.primary,
    fontWeight: 600,
  },
}));

export default function BuyNowModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title} align="center" gutterBottom>
          Comprar ahora
        </Typography>
        <Typography align="center" className={classes.text}>
          Con este botón, el comprador procede directamente al checkout sin
          pasar por el carrito de compras.
        </Typography>
        <Typography align="center" className={classes.text}>
          <span className={classes.highlight}>Ideal para:</span> Productos de
          compra única o cuando quieres agilizar el proceso de compra.
        </Typography>
        <Typography align="center" className={classes.text}>
          El comprador puede agregar opciones del producto (talla, color, etc.)
          antes de proceder al pago.
        </Typography>
      </div>
    </CustomModal>
  );
}
